import Vue from "vue";
import { Menu } from "ant-design-vue";
import "../assets/styles/antdv.less";

Vue.use(Menu);
